import { createContext, useContext } from "react"

type OrderTabContextType = {
  switchToDiscountTab: () => void
  switchToUpdatesTab: () => void
}

const OrderTabContext = createContext<OrderTabContextType | undefined>(undefined)

export const useOrderTabContext = () => {
  const context = useContext(OrderTabContext)
  if (!context) {
    return {
      switchToDiscountTab: () => {},
      switchToUpdatesTab: () => {}
    }
  }
  return context
}

export const OrderTabProvider = OrderTabContext.Provider